'use client';

import * as CheckboxPrimitive from '@radix-ui/react-checkbox';
import * as React from 'react';

import { Icon } from '@eliadmin/core/src/components/dlz/ui/icon';
import { cn } from '@eliadmin/core/src/utils/style-utils';

/**
 * Figma component "Checkbox": 24 px box, radius 6, 1.2 px border/hover; checked = bg/brand with a
 * white check (19 px).
 */
const Checkbox = React.forwardRef<
  React.ElementRef<typeof CheckboxPrimitive.Root>,
  React.ComponentPropsWithoutRef<typeof CheckboxPrimitive.Root> & {
    iconClassName?: string;
  }
>(({ className, iconClassName, ...props }, ref) => (
  <CheckboxPrimitive.Root
    ref={ref}
    className={cn(
      'peer flex size-6 shrink-0 items-center justify-center rounded-[6px] border-[1.2px] border-[#9096A0] bg-white transition-colors',
      'hover:border-[#0F1012] focus-visible:outline-none focus-visible:ring-2 focus-visible:ring-[#0F1012] focus-visible:ring-offset-2',
      'disabled:cursor-not-allowed disabled:opacity-50',
      'data-[state=checked]:border-[#D7191F] data-[state=checked]:bg-[#D7191F] data-[state=checked]:text-white',
      className,
    )}
    {...props}
  >
    <CheckboxPrimitive.Indicator className="flex items-center justify-center text-current">
      <Icon name="check" size={19} className={iconClassName} />
    </CheckboxPrimitive.Indicator>
  </CheckboxPrimitive.Root>
));
Checkbox.displayName = CheckboxPrimitive.Root.displayName;

export { Checkbox };
